import type { ComponentProps, FC, SVGProps } from 'react';

type IconProps = {
  color?: string;
  stroke?: string;
  className?: string;
} & Omit<ComponentProps<'svg'>, 'color' | 'stroke' | 'width' | 'height'>;

const createIcon = (Component: FC<SVGProps<SVGSVGElement>>) => {
  const IconComponent = ({
    color = 'transparent',
    stroke = 'transparent',
    className,
    ...props
  }: IconProps) => <Component fill={color} stroke={stroke} className={className} {...props} />;
  IconComponent.displayName = 'IconComponent';
  return IconComponent;
};

export default createIcon;
